import apiHandler from "../core/apiHandler";
const documentIdentificationTypeApi = apiHandler('document-identification-types');
export default documentIdentificationTypeApi;
